import React from 'react';
import { Period } from '@frontend/gql/social/graphql';
import { useGetPreviousIntervalRange, calculatePrecisionFromDateRange } from '../utils';
import { AdsQueryVariables } from './useAdsAnalyticsParams';

interface UseIntervalRangesProps {
  queryVariables: AdsQueryVariables;
}

export const useIntervalRanges = ({ queryVariables }: UseIntervalRangesProps) => {
  // Create interval ranges from dates
  const currentIntervalRange = React.useMemo(
    () => ({
      startDate: queryVariables.startDate,
      endDate: queryVariables.endDate,
      precision: calculatePrecisionFromDateRange(queryVariables.startDate, queryVariables.endDate) as Period,
    }),
    [queryVariables.startDate, queryVariables.endDate],
  );

  const previousIntervalRange = useGetPreviousIntervalRange(currentIntervalRange);

  return {
    currentIntervalRange,
    previousIntervalRange,
  };
};
